
import store from '../../index.js'
import api from '../../../utils/api'

export const modules = ({
    store
})

export const state = ({
    _items: [],
    _page: {}
});


export const mutations = {  
    setItems(state, items){
        console.log(items)
        state._items = [];
        state._items = items;
    },
    setPage(state, page){
        state._page = {};
        state._page = page;
    }
};

export const actions = {
    async acAutoApproveList({commit}, params) {
        try {
            const url = `/api/v1/auto-approve`;
            const res = await api.get(url, {
                params: params
            });
            commit('setItems', res.data?.code === 0 ? res.data?.data.items : []);
            const page = {
                pageSize: res.data.data.pageSize,
                totalCount: res.data.data.totalCount,
                totalPage: res.data.data.totalPage,
            }
            commit('setPage', page);
        } catch (error) {
            return null;
        }
    },
    async acAutoApproveConfirm({commit}, id) {
        try {
            const url = `/api/v1/auto-approve/${id}`;
            const res = await api.patch(url);
            return res.data?.code === 0 ? true : false;
        } catch (error) {
            return false;
        }
    },
};


export const getters = {

};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}